import React, { useState } from "react";


function Donacije() {
    const [open, setOpen] = useState(false);
    const [tip, setTip] = useState("");
    const [ime, setIme] = useState("");
    const [email, setEmail] = useState("");
    const [znesek, setZnesek] = useState("");

    const openModal = (selected) => {
        setTip(selected);
        setOpen(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // VALIDACIJA
        if (tip === "prijatelj" && znesek < 10) return alert("Min 10€");
        if (tip === "dobrotnik" && (znesek < 50 || znesek > 200)) return alert("50€ - 200€");
        if (tip === "mecen" && znesek < 200) return alert("Min 200€");

        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/donacije`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ ime, email, znesek, tip })
            });

            const data = await res.json();
            alert(data.message);
            setOpen(false);

        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="donacije-page">

            {/* INTRO */}
            <section className="donacije-intro">
                <h1>Postani abonent</h1>
                <p>
                    Vam je naš abonma všeč? Želite o njem slišati več? Nas želite podpreti?
                    Pridružite se kot podpornik in pomagajte soustvarjati prihodnost.
                </p>
            </section>

            {/* KARTICE */}
            <div className="donacije-grid">
                <div className="donacija-card">
                    <h2>Prijatelj</h2>
                    <p>10€+</p>
                    <button onClick={() => openModal("prijatelj")}>Izberi</button>
                </div>

                <div className="donacija-card highlight">
                    <h2>Dobrotnik</h2>
                    <p>50€ - 200€</p>
                    <button onClick={() => openModal("dobrotnik")}>Izberi</button>
                </div>

                <div className="donacija-card">
                    <h2>Mecen</h2>
                    <p>200€+</p>
                    <button onClick={() => openModal("mecen")}>Izberi</button>
                </div>
            </div>

            {/* POPUP */}
            {open && (
                <div className="modal-overlay" onClick={() => setOpen(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>

                        <h2>{tip.toUpperCase()}</h2>

                        {/* OPIS */}
                        <p className="modal-opis">
                            {tip === "prijatelj" && "Prejem novic, vabil in možnost darila."}
                            {tip === "dobrotnik" && "Ekskluziven koncert + dodatne vsebine."}
                            {tip === "mecen" && "VIP dostop + stalni sedež + osebna zahvala."}
                        </p>

                        {/* BULLETI */}
                        <ul className="modal-list">
                            {tip === "prijatelj" && (
                                <>
                                    <li>Prijava na novice</li>
                                    <li>Prejem vabil</li>
                                    <li>Možnost darila in brošure</li>
                                </>
                            )}

                            {tip === "dobrotnik" && (
                                <>
                                    <li>Vse od prijatelja</li>
                                    <li>Ekskluziven koncert</li>
                                    <li>Dostop do vsebin</li>
                                </>
                            )}

                            {tip === "mecen" && (
                                <>
                                    <li>VIP dostop</li>
                                    <li>Stalni sedež</li>
                                    <li>Osebna zahvala</li>
                                </>
                            )}
                        </ul>

                        {/* QUICK ZNESKI */}
                        <div className="donation-options">
                            {tip === "prijatelj" && (
                                <>
                                    <button onClick={() => setZnesek(10)}>10€</button>
                                    <button onClick={() => setZnesek(20)}>20€</button>
                                    <button onClick={() => setZnesek(50)}>50€</button>
                                </>
                            )}

                            {tip === "dobrotnik" && (
                                <>
                                    <button onClick={() => setZnesek(50)}>50€</button>
                                    <button onClick={() => setZnesek(100)}>100€</button>
                                    <button onClick={() => setZnesek(200)}>200€</button>
                                </>
                            )}

                            {tip === "mecen" && (
                                <>
                                    <button onClick={() => setZnesek(200)}>200€</button>
                                    <button onClick={() => setZnesek(300)}>300€</button>
                                    <button onClick={() => setZnesek(500)}>500€</button>
                                </>
                            )}
                        </div>

                        {/* FORM */}
                        <form onSubmit={handleSubmit}>
                            <input
                                type="text"
                                placeholder="Ime in priimek"
                                value={ime}
                                onChange={(e) => setIme(e.target.value)}
                                required
                            />

                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />

                            <input
                                type="number"
                                placeholder="Znesek (€)"
                                value={znesek}
                                onChange={(e) => setZnesek(e.target.value)}
                                required
                            />

                            <button type="submit">Doniraj</button>
                        </form>

                    </div>
                </div>
            )}
        </div>
    );
}

export default Donacije;